import Vue from 'vue';
import Vuex from 'vuex';
import menu from './modules/menu';
import user from './modules/user';
import requirement from './modules/requirement';
import nedmand from './modules/ndemand'
Vue.use(Vuex);

// 新建并暴露store
const store = new Vuex.Store({
    modules: {
        menu,
        user,
        requirement
    }
    // getters
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js